@if (isLoggedIn() && functionMap) {
        <mat-menu #projectsMenu [overlapTrigger]="false" yPosition="below">
            @if (!smallScreen) {
                @if (canEditProjectDetails()) {
                    <button mat-menu-item (click)="executeFunction(FUNCTION.EDIT_PROJECT)"
                        [disabled]="functionMap[FUNCTION.EDIT_PROJECT].disabled">
                        <mat-icon [fontIcon]="functionMap[FUNCTION.EDIT_PROJECT].icon"></mat-icon>
                        <span>{{functionMap[FUNCTION.EDIT_PROJECT].name}}</span>
                    </button>
                }
                <button mat-menu-item (click)="executeFunction(FUNCTION.CREATE_PROJECT)"
                    [disabled]="functionMap[FUNCTION.CREATE_PROJECT].disabled">
                    <mat-icon [fontIcon]="functionMap[FUNCTION.CREATE_PROJECT].icon"></mat-icon>
                    <span>{{functionMap[FUNCTION.CREATE_PROJECT].name}}</span>
                </button>
                <mat-divider></mat-divider>
            }

            @for (p of projectMenuItems; track p._key) {
                <button mat-menu-item [disabled]="p.role == null" (click)="selectWorkspace(p._key)">
                    @if (p.sandbox) {
                        <mat-icon>snowing_heavy</mat-icon>
                    }@else {
                        <mat-icon>work</mat-icon>
                    }
                    <span class="truncated-name menu-name" [matTooltip]="p.name" matTooltipPosition="right">{{p.name}}</span>
                </button>
            }
        </mat-menu>

        <mat-menu #modelsMenu="matMenu" style="max-width:none !important;">
            @if (!smallScreen && !isInsightsScreen()) {
                @if (linqset && canEditModelDetails()) {
                    <button mat-menu-item (click)="executeFunction(FUNCTION.EDIT_MODEL_DETAILS)"
                        [disabled]="functionMap[FUNCTION.EDIT_MODEL_DETAILS].disabled">
                        <mat-icon [fontIcon]="functionMap[FUNCTION.EDIT_MODEL_DETAILS].icon"></mat-icon>
                        <span>{{functionMap[FUNCTION.EDIT_MODEL_DETAILS].name}}</span>
                    </button>
                }

                <button mat-menu-item (click)="executeFunction(FUNCTION.CREATE_MODEL)"
                    [disabled]="functionMap[FUNCTION.CREATE_MODEL].disabled">
                    <mat-icon [fontIcon]="functionMap[FUNCTION.CREATE_MODEL].icon"></mat-icon>
                    <span>{{functionMap[FUNCTION.CREATE_MODEL].name}}</span>
                </button>
                <mat-divider></mat-divider>
            }
            <button mat-menu-item [routerLink]="getOrganisationModelRoute()">
                <mat-icon>domain</mat-icon>
                <span>Organisation model</span>
            </button>
            <button mat-menu-item [routerLink]="getPeopleSystemsModelRoute()">
                <mat-icon>people</mat-icon>
                <span>People and systems</span>
            </button>
            <mat-divider></mat-divider>
            @for (m of modelMenuItems; track m._key) {
                <button mat-menu-item [disabled]="m.role == null" (click)="selectModel(m.model)">
                    <span class="image-text">
                        <app-node-svg [settings]="m.settings"/>
                        {{m.name}}
                    </span>
                </button>
            }
        </mat-menu>

    <mat-toolbar [color]="getColour()">
        <!--First section, home, organisations, organisation and insights menus -->
        <div class="menu-section">
            <img [src]="IMAGE_LINQ" alt="LINQ" width="80" height="60" class="linq-image" (click)="goHome()">
            @if (organisation) {
                <div id="home-button">
                    <button mat-button matTooltip="Return to dashboard" aria-label="Organisation dashboard" (click)="goHome()">
                        <mat-icon>home</mat-icon>
                    </button>
                </div>
            }
            @if (dropdown) {
                <div>
                    <button mat-icon-button [matMenuTriggerFor]="mainMenu" matTooltip="Menu" aria-label="Main menu"><mat-icon>menu</mat-icon></button>
                </div>

                <mat-menu #mainMenu="matMenu">
                    @if (organisation) {
                        <!-- the organisation's pages and settings: on a small screen, its pages only (see organisationMenu) -->
                        <button mat-menu-item [matMenuTriggerFor]="organisationMenu">{{organisation.name}}</button>
                        <button mat-menu-item [matMenuTriggerFor]="analysisMenu" data-testid="menu-analysis">Analysis</button>
                        <button mat-menu-item matTooltip="Switch between current state and projects" [matMenuTriggerFor]="projectsMenu">
                            <span>{{getWorkspaceName()}}</span>
                        </button>
                        <button mat-menu-item matTooltip="Select or create a model" [matMenuTriggerFor]="modelsMenu">
                            <span>{{linqset?linqset.name:(scopeModelName || "Models menu")}}</span>
                        </button>
                    }
                    <button mat-menu-item matTooltip="View list of your organisations" routerLink="/organisations">Organisations</button>
                </mat-menu>
            }@else {
                @if (!smallScreen && organisation) {
                    <button mat-button class="name-button" [matTooltip]="organisation.name + ': organisation menu'" [matMenuTriggerFor]="organisationMenu"><span class="truncated-name">{{organisation.name}}</span></button>
                }
                @if (organisation) {
                    <button mat-button class="name-button" matTooltip="The organisation's analysis: its overview, actions, people, systems and more" [matMenuTriggerFor]="analysisMenu" data-testid="menu-analysis">Analysis</button>
                }
            }
            <mat-menu #tags="matMenu">
                @for (tagGroup of getTagGroups(); track tagGroup._key) {
                    <button mat-menu-item (click)="executeFunction(FUNCTION.CREATE_TAG_GROUP, tagGroup)"
                        [disabled]="functionMap[FUNCTION.CREATE_TAG_GROUP].disabled">
                        <span>{{getTagGroupName(tagGroup)}}</span>
                    </button>
                }
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="executeFunction(FUNCTION.CREATE_TAG_GROUP)"
                    [disabled]="functionMap[FUNCTION.CREATE_TAG_GROUP].disabled">
                    <mat-icon [fontIcon]="functionMap[FUNCTION.CREATE_TAG_GROUP].icon"></mat-icon>
                    <span>{{functionMap[FUNCTION.CREATE_TAG_GROUP].name}}</span>
                </button>
            </mat-menu>
            <!-- the analysis screen's views, as its tabs offer them -->
            <mat-menu #analysisMenu [overlapTrigger]="false" yPosition="below">
                @if (organisation) {
                    @for (lens of lenses; track lens.key) {
                        <button mat-menu-item (click)="openLens(lens)" [matTooltip]="lens.description" matTooltipPosition="right" [attr.data-testid]="'menu-analysis-' + lens.key">
                            <mat-icon>{{lens.icon}}</mat-icon>
                            <span>{{lens.label}}</span>
                        </button>
                    }
                }
            </mat-menu>
            <mat-menu #organisationMenu [overlapTrigger]="false" yPosition="below">
                @if (organisation) {
                    <!-- changing the organisation is left to a larger screen, as creating and editing projects and models is -->
                    @if (!smallScreen) {
                    <button mat-menu-item (click)="executeFunction(FUNCTION.EDIT_ORGANISATION)"
                        [disabled]="functionMap[FUNCTION.EDIT_ORGANISATION].disabled">
                        <mat-icon [fontIcon]="functionMap[FUNCTION.EDIT_ORGANISATION].icon"></mat-icon>
                        <span>{{functionMap[FUNCTION.EDIT_ORGANISATION].name}}</span>
                    </button>
                    <button mat-menu-item (click)="executeFunction(FUNCTION.CREATE_PROJECT)"
                        [disabled]="functionMap[FUNCTION.CREATE_PROJECT].disabled">
                        <mat-icon [fontIcon]="functionMap[FUNCTION.CREATE_PROJECT].icon"></mat-icon>
                        <span>{{functionMap[FUNCTION.CREATE_PROJECT].name}}</span>
                    </button>
                    <button mat-menu-item (click)="executeFunction(FUNCTION.CREATE_MODEL)"
                        [disabled]="functionMap[FUNCTION.CREATE_MODEL].disabled">
                        <mat-icon [fontIcon]="functionMap[FUNCTION.CREATE_MODEL].icon"></mat-icon>
                        <span>{{functionMap[FUNCTION.CREATE_MODEL].name}}</span>
                    </button>
                    }

                    <button mat-menu-item (click)="openModelWalkthrough()" data-testid="menu-model-walkthrough">
                        <mat-icon>tour</mat-icon><span>Model walkthrough</span>
                    </button>
                    <button mat-menu-item (click)="gotoBillingUrl()" [disabled]="!isOrgAdmin()">
                        <mat-icon>attach_money</mat-icon><span>Statistics & Billing</span>
                    </button>
                    @if (!smallScreen) {
                    <button mat-menu-item [matMenuTriggerFor]="tags" [disabled]="!isOrgAdmin()">
                        <mat-icon>local_offer</mat-icon>
                        <span>Node tag groups</span>
                    </button>
                    <button mat-menu-item [matMenuTriggerFor]="emissionFactorsMenu" [disabled]="!isOrgAdmin()">
                        <mat-icon>co2</mat-icon>
                        <span>Emission factors</span>
                    </button>
                    <button mat-menu-item (click)="executeFunction(FUNCTION.EDIT_MODEL_TAGS)"
                        [disabled]="functionMap[FUNCTION.EDIT_MODEL_TAGS].disabled">
                        <mat-icon [fontIcon]="functionMap[FUNCTION.EDIT_MODEL_TAGS].icon"></mat-icon>
                        <span>{{functionMap[FUNCTION.EDIT_MODEL_TAGS].name}}</span>
                    </button>
                    <button mat-menu-item (click)="executeFunction(FUNCTION.RESTORE_MODEL)"
                        [disabled]="functionMap[FUNCTION.RESTORE_MODEL].disabled || !hasDeletedModels()">
                        <mat-icon [fontIcon]="functionMap[FUNCTION.RESTORE_MODEL].icon"></mat-icon>
                        <span>{{functionMap[FUNCTION.RESTORE_MODEL].name}}</span>
                    </button>
                    }
                    <button mat-menu-item (click)="executeFunction(FUNCTION.REFRESH_INSIGHTS)"
                        [disabled]="functionMap[FUNCTION.REFRESH_INSIGHTS].disabled">
                        <mat-icon [fontIcon]="functionMap[FUNCTION.REFRESH_INSIGHTS].icon"></mat-icon>
                        <span>{{functionMap[FUNCTION.REFRESH_INSIGHTS].name}}</span>
                    </button>
                    @if (!smallScreen) {
                    <button mat-menu-item (click)="executeFunction(FUNCTION.CLOSE_ORGANISATION)"
                        [disabled]="functionMap[FUNCTION.CLOSE_ORGANISATION].disabled">
                        <mat-icon [fontIcon]="functionMap[FUNCTION.CLOSE_ORGANISATION].icon"></mat-icon>
                        <span>{{functionMap[FUNCTION.CLOSE_ORGANISATION].name}}</span>
                    </button>
                    @if (isSysAdminUser()) {
                        <button mat-menu-item (click)="cleanOrphans()">
                            <span>Clean orphans</span>
                        </button>
                    }
                    }
                }
            </mat-menu>
        </div>
        <!-- middle section workpspace and model-->
        @if (organisation && !dropdown) {
            <div class="menu-section">
                <div id="workspaces-menu">
                    <button mat-button class="name-button" [matTooltip]="getWorkspaceName() + ': switch between current state and projects'" [matMenuTriggerFor]="projectsMenu">
                        <mat-icon fontIcon="keyboard_arrow_down"></mat-icon>
                        <span class="truncated-name">{{getWorkspaceName()}}</span>
                    </button>
                </div>
                <div id="models-menu">
                    <button mat-button class="name-button" [matTooltip]="(linqset ? linqset.name + ': ' : '') + 'select or create a model'" [matMenuTriggerFor]="modelsMenu">
                        <mat-icon fontIcon="keyboard_arrow_down"></mat-icon>
                        <span class="truncated-name">{{linqset?linqset.name:(scopeModelName || "Models menu")}}</span>
                    </button>
                </div>
                @if (screen === SCREEN.ORGANISATION_HOME && false) {
                    <!-- Have turned this off for now. may implement in future-->
                    <div class="models-filter">
                        <app-group-selection #modelselection [groups]="modelsData" (openedEvent)="onModelFilterOpened($event)" [multiple]="true" placeholder="Models filter"></app-group-selection>
                    </div>
                }
            </div>
        }
        <!-- right side section-->
        <div class="menu-section">
            @if (screen !== SCREEN.ORGANISATIONS && !dropdown) {
                <button mat-button matTooltip="View list of your organisations" style="padding-right: 30px;" routerLink="/organisations">
                    <span>Organisations</span>
                </button>
            }

            @if (!smallScreen) {
                <app-search [organisation]="organisation" [linqset]="linqset" [screen]="screen" [graphNodes]="searchNodes" (selectNodeEvent)="handleSelectNodeEvent($event)" (functionEvent)="handleFunctionEvent($event)"></app-search>
            }
            @if (!smallScreen) {
                @if (isModelScreen() && linqset) {
                    <div id="save-menu">

                    @if (!linqset.changes || !isThisLinqsetDirty()) {
                        <span class="up-to-date" matTooltip="The model has no changes to save" role="status">
                            <mat-icon class="no-change-icon">check_circle_outline</mat-icon>
                            <span>Up to date</span>
                        </span>
                    }@else {
                        <button mat-raised-button matTooltip="The model has changes that need saving" [matMenuTriggerFor]="modelChangesMenu"
                            [attr.aria-label]="getNumberOfChanges() + ' unsaved ' + (getNumberOfChanges() === 1 ? 'change' : 'changes')">
                            <div class="badge">{{getNumberOfChanges()}}</div>
                            <div style="padding-left: 30px;">Changes</div>
                        </button>
                        <mat-menu #modelChangesMenu [overlapTrigger]="false" yPosition="below">
                            <button mat-menu-item (click)="executeFunction(FUNCTION.SAVE_MODEL)" [disabled]="functionMap[FUNCTION.SAVE_MODEL].disabled">
                                <mat-icon [fontIcon]="functionMap[FUNCTION.SAVE_MODEL].icon"></mat-icon><span>{{functionMap[FUNCTION.SAVE_MODEL].name}}</span>
                            </button>
                            <mat-divider></mat-divider>
                            <ul class="change-list">
                                @for (c of getListOfChanges(); track $index) {
                                    <li>{{c}}</li>
                                }
                            </ul>
                            <mat-divider></mat-divider>
                            <button mat-menu-item (click)="executeFunction(FUNCTION.CANCEL_CHANGES)" [disabled]="functionMap[FUNCTION.CANCEL_CHANGES].disabled">
                                <mat-icon [fontIcon]="functionMap[FUNCTION.CANCEL_CHANGES].icon"></mat-icon><span>{{functionMap[FUNCTION.CANCEL_CHANGES].name}}</span>
                            </button>
                        </mat-menu>
                    }
                    </div>
                }
                @if (organisation) {
                    <span class="node-count">Node count: {{organisation.numNodes | number}}</span>
                    <button mat-raised-button [style]="getBillingColour()" [matTooltip]="billingText + ' · Node count: ' + (organisation.numNodes | number)" (click)="clickBillingButton()" [disabled]="!isOrgAdmin()">
                        <mat-icon>attach_money</mat-icon>
                        <span>{{billingText}}</span>
                    </button>
                }
            }

            <app-notifications [organisation]="organisation"></app-notifications>
            <mat-menu #emissionFactorsMenu [overlapTrigger]="false" yPosition="below">
                @if (organisation) {
                    <button mat-menu-item (click)="executeFunction(FUNCTION.MAINTAIN_EMISSION_FACTOR)">
                        <span>Create emission factor</span>
                    </button>
                    <mat-divider></mat-divider>
                    @for (ef of organisation.emissionFactors; track ef._key) {
                        <button mat-menu-item (click)="executeFunction(FUNCTION.MAINTAIN_EMISSION_FACTOR, ef)">
                            <span>{{ef.name + ' (' + ef.scope + ')'}}</span>
                        </button>
                    }
                }
            </mat-menu>

            @if (isSysAdminUser() && !smallScreen) {
                <button mat-icon-button matTooltip="Administration menu" aria-label="Administration menu" [matMenuTriggerFor]="adminMenu">
                    <mat-icon>settings</mat-icon>
                </button>
                <mat-menu #adminMenu [overlapTrigger]="false" yPosition="below">
                    <button mat-menu-item routerLink="/administration">
                        <mat-icon>monitoring</mat-icon><span>Analytics</span>
                    </button>
                    <button mat-menu-item routerLink="/billing">
                        <mat-icon>attach_money</mat-icon><span>Billing</span>
                    </button>
                    <button mat-menu-item routerLink="/organisations">
                        <mat-icon>person</mat-icon><span>Organisations</span>
                    </button>
                    <button mat-menu-item routerLink="/users">
                        <mat-icon
                            [fontIcon]="functionMap[FUNCTION.MANAGE_USERS].icon"></mat-icon><span>{{functionMap[FUNCTION.MANAGE_USERS].name}}</span>
                    </button>
                    <!--button mat-menu-item (click)="tuneAI()">
                <mat-icon>person</mat-icon><span>Tune AI</span>
                </button-->
                </mat-menu>
            }
            <div id="help-menu">
                <button mat-icon-button matTooltip="Help and support menu" aria-label="Help and support menu" [matMenuTriggerFor]="helpMenu">
                    <mat-icon>help</mat-icon>
                </button>
            </div>

            <mat-menu #helpMenu [overlapTrigger]="false" yPosition="below">
                <button mat-menu-item (click)="openHelpChat()">
                    <mat-icon>forum</mat-icon><span>Ask LINQ AI</span>
                </button>
                <button mat-menu-item (click)="openGuide()" data-testid="menu-help-guides">
                    <mat-icon>menu_book</mat-icon><span>Help guides</span>
                </button>
                @for (g of screenGuides; track g.slug) {
                    <button mat-menu-item (click)="openGuide(g.slug)" class="screen-guide">
                        <mat-icon>article</mat-icon><span>{{g.title}}</span>
                    </button>
                }
                <mat-divider></mat-divider>
                @if (hasTour()) {
                    <button mat-menu-item (click)="executeFunction(FUNCTION.SCREEN_TOUR)">
                        <mat-icon [fontIcon]="functionMap[FUNCTION.SCREEN_TOUR].icon"></mat-icon><span>{{functionMap[FUNCTION.SCREEN_TOUR].name}}</span>
                    </button>
                }
                <button mat-menu-item (click)="openOnboardingPanel()">
                    <mat-icon>handshake</mat-icon>
                    <span>Onboarding help and videos</span>
                </button>
                @if (!smallScreen) {
                    <button mat-menu-item (click)="openWalkthrough()">
                        <mat-icon>school</mat-icon><span>Learn the basics of modelling</span>
                    </button>
                }
                @if (hasDemoOrganisation()) {
                    <button mat-menu-item (click)="openDemoWalkthrough()" data-testid="menu-demo-walkthrough">
                        <mat-icon>tour</mat-icon><span>Demo organisation walkthrough</span>
                    </button>
                }
                @if (!smallScreen) {
                    @if (organisation) {
                        <button mat-menu-item (click)="openTutorialModel()">
                            <mat-icon>school</mat-icon>
                            <span>Tutorials</span>
                        </button>
                    }
                }

                <mat-divider></mat-divider>
                <a mat-menu-item href="https://www.youtube.com/playlist?list=PL9tettICfw4LknLwO35xzLQUoWUE-sgFd"
                    target="_blank" rel="noopener"><mat-icon>video_library</mat-icon><span>All videos</span></a>
                <mat-divider></mat-divider>
                <a mat-menu-item href="https://support.thinklikelinq.com/support/home"
                    target="_blank" rel="noopener"><mat-icon>support</mat-icon><span>LINQ support site</span></a>
                <button mat-menu-item (click)="executeFunction(FUNCTION.CREATE_TICKET)"
                    [disabled]="functionMap[FUNCTION.CREATE_TICKET].disabled">
                    <mat-icon [fontIcon]="functionMap[FUNCTION.CREATE_TICKET].icon"></mat-icon>
                    <span>{{functionMap[FUNCTION.CREATE_TICKET].name}}</span>
                </button>
                <mat-divider></mat-divider>
                <a mat-menu-item href="https://thinklikelinq.com/terms-of-use/"
                    target="_blank" rel="noopener"><mat-icon>article</mat-icon><span>Terms of use</span></a>
                <a mat-menu-item href="https://thinklikelinq.com/privacy-policy/"
                    target="_blank" rel="noopener"><mat-icon>policy</mat-icon><span>Privacy policy</span></a>
            </mat-menu>
            <button mat-icon-button matTooltip="User menu" aria-label="User menu" [matMenuTriggerFor]="userAccountMenu">
                <mat-icon>account_circle</mat-icon>
            </button>
            <mat-menu #userAccountMenu [overlapTrigger]="false" yPosition="below">
                <button mat-menu-item (click)="executeFunction(FUNCTION.EDIT_USER_DETAILS)"
                    [disabled]="functionMap[FUNCTION.EDIT_USER_DETAILS].disabled">
                    <mat-icon [fontIcon]="functionMap[FUNCTION.EDIT_USER_DETAILS].icon"></mat-icon>
                    <span>{{functionMap[FUNCTION.EDIT_USER_DETAILS].name}}</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="executeFunction(FUNCTION.LOGOUT)"
                    [disabled]="functionMap[FUNCTION.LOGOUT].disabled">
                    <mat-icon [fontIcon]="functionMap[FUNCTION.LOGOUT].icon"></mat-icon>
                    <span>{{functionMap[FUNCTION.LOGOUT].name}}</span>
                </button>
                <mat-divider></mat-divider>
                <a mat-menu-item href="https://thinklikelinq.com/release-notes/"
                    target="_blank" rel="noopener"><mat-icon>summarize</mat-icon><span>Release notes</span></a>
                <div class="version">{{getVersion()}}</div>
            </mat-menu>
        </div>
    </mat-toolbar>

    <!-- the screen tour, always to hand on the screens that have one, above the hints button -->
    @if (hasTour() && !smallScreen) {
        <button id="screen-tour" mat-mini-fab class="tour-fab" color="accent" (click)="executeFunction(FUNCTION.SCREEN_TOUR)" [disabled]="functionMap[FUNCTION.SCREEN_TOUR].disabled"
            matTooltip="Explain screen to me" matTooltipPosition="left" aria-label="Explain screen to me" data-testid="screen-tour-fab">
            <mat-icon [fontIcon]="functionMap[FUNCTION.SCREEN_TOUR].icon"></mat-icon>
        </button>
    }
}